import React, { useEffect, useState } from 'react'
import ApiService from 'services/api.service';


const useSegmentSizeData = () => {
  const [sizeData, setSizeData] = useState<{ size: number; total: number, message: string }>({} as any);
  const [isLoading, setIsLoading] = useState(true);

  const getSizeData = async (segmentId: string) => {
    if (!segmentId) return;
    setIsLoading(true);
    const { data } = await ApiService.post({
      url: "/segments/size",
      options: {
        inclusionCriteria: {
          query: {
            type: "all",
            statements: [{
              type: "Segment",
              segmentId,
            }]
          }
        },
      },
    });

    setSizeData(data);
    setIsLoading(false);
  }
  return {
    sizeData,
    isLoading,
    getSizeData
  }
}

interface SegmentSizeBoxProps {
  segmentId: string;
}

export const SegmentSizeBox = (props: SegmentSizeBoxProps) => {
  const { sizeData: data, isLoading, getSizeData } = useSegmentSizeData();
  const percentage = data
    ? Math.ceil((data.size / data.total) * 100)
    : 0;
  useEffect(() => {
    getSizeData(props.segmentId)
  }
    , [props.segmentId])

  return (
    (
      <div
        className={`${isLoading && "opacity-70 animate-pulse pointer-events-none"
          } relative flex items-center py-[8.45px] max-w-[400px] px-[11.45px] rounded bg-[#F3F4F6]`}
      >
        <div
          className="mr-[2px] min-w-[15px] min-h-[15px] border border-[#6366F1] rounded-full"
          style={{
            background: `
                  conic-gradient(
                    #6366F1 ${percentage}%,
                    white ${percentage}% 100%
                  )
                `,
          }}
        />
        {isLoading ? (
          <span className="ml-[6px] text-[#4B5563] font-roboto text-[14px] leading-[22px]">
            Loading...
          </span>
        ) : (
          (data && data.size && data.total) ? (
            <>
              <span className="text-[#6366F1] font-roboto font-semibold text-[14px] leading-[22px]">
                {percentage}%
              </span>
              <span className="ml-[6px] text-[#4B5563] font-roboto text-[14px] leading-[22px]">
                of users estimated reached ≈{" "}
                {Intl.NumberFormat("en", {
                  notation: "compact",
                }).format(data.size)}
              </span>
            </>
          ) : (
            <span className="ml-[6px] text-[#4B5563] font-roboto text-[14px] leading-[22px]">
              {data.message}
            </span>
          )
        )}
        <div className="absolute top-full left-[25px] z-[0] h-[10px] w-[1px] bg-[#E5E7EB]" />
      </div>
    )
  )
}